/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoViewportController {
    /** @ngInject */
    constructor($state, $log, authenticationService, counterService, $rootScope) {
        this.$state = $state;
        this.$log = $log;
        this.authenticationService = authenticationService;
        this.counterService = counterService;
        this.$rootScope = $rootScope;
        this.$log.debug('Controller \'GmaoViewport\' loaded');
    }

    $onInit() {
        this.counterService.loadCount();
    }

    /**
     * Forces user logout, and redirects to the login page.
     */
    logout() {
        this.authenticationService.logout().then(disconnected => {
            if (disconnected) {
                this.$log.debug('Successfully disconnected');
                this.$state.go('login');
            } else {
                this.$log.debug('Not connected');
            }
        });
    }
}

export const gmaoViewportComponent = {
    template: require('./gmao-viewport.html'),
    controller: GmaoViewportController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoViewport.js